import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    height: '100%',
  },
  tabsIndicator: {
    display: 'none',
  },
  tabRoot: {
    padding: theme.spacing(2),
    minWidth: 'unset',
    ['@media screen and (max-width: 1450px)']: {
      padding: theme.spacing(1),
    },
  },
  tabWrapper: {
    alignItems: 'flex-start',
  },
  tabTitle: {
    textTransform: 'none',
    color: '#37474F',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    ['@media screen and (max-width: 1450px)']: {
      fontSize: 12,
    },
  },
  tabSelected: {
    backgroundColor: '#ECEFF1',
  },
  dateContainer: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '& > div': {
      flexGrow: 1,
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
}));

export default useStyles;
